/**
 * Handles screen positions and spacing calculations for screens that can't be handled through CSS
 */
import { isMobile } from "../lib";
const HeightMixin = {
  data: function () {
    return {
      heightObserver: null,
      height: 0,
      elContentHeight: 0,
      elStepHeaderHeight: 0,
      elControlsHeight: 0,
      inited: false,
    };
  },
  computed: {
    style: function () {
      return isMobile()
        ? `height: ${this.height}px`
        : `height: calc(${this.height}px - 5.5em)`;
    },
  },
  mounted: function () {
    window.addEventListener("DOMContentLoaded", () => {
      this.initObserver();
    });
  },
  methods: {
    initObserver: function () {
      this.heightObserver = new IntersectionObserver(
        (event) => {
          if (event.length && event[0].isIntersecting) {
            this.$nextTick(() => {
              if (!this.inited) {
                this.getContentHeight();
                this.updateHeight();
                this.inited = true;
              }
            });
          }
        },
        {
          rootMargin: "0px",
          threshold: 0.1,
        }
      );
      this.heightObserver.observe(this.$refs.elDiamondSelector);
    },
    updateHeight: function () {
      var elAppliedFilters = this.$refs.elDiamondSelector.querySelector(
        ".rb-applied-filters"
      );
      var appliedFiltersHeight = elAppliedFilters
        ? elAppliedFilters.getBoundingClientRect().height
        : 0;

      this.height =
        this.elContentHeight -
        this.elStepHeaderHeight -
        this.elControlsHeight -
        appliedFiltersHeight;

      if (isMobile()) {
        this.height = this.height - 48; // remove padding
        this.height = this.height - 70;
      }

      // console.log("height", this.height);
    },
    getContentHeight: function () {
      var elContent = this.$refs.elDiamondSelector.closest(".rb-content");
      var elStepHeader = this.$refs.elDiamondSelector.closest(".rb-step")
        ? this.$refs.elDiamondSelector
            .closest(".rb-step")
            .querySelector(".rb-step-header")
        : null;
      var elControls = this.$refs.elDiamondSelector.querySelector(
        ".rb-diamond-controls"
      );

      this.elContentHeight = elContent
        ? elContent.getBoundingClientRect().height
        : 0;
      this.elStepHeaderHeight = elStepHeader
        ? elStepHeader.getBoundingClientRect().height
        : 0;
      this.elControlsHeight = elControls
        ? elControls.getBoundingClientRect().height
        : 0;

      /* console.log( 
        "content height",
        this.elContentHeight,
        this.elStepHeaderHeight,
        this.elControlsHeight
      ); */
    },
  },
};

export default HeightMixin;
